import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Mic, Sparkles, Zap } from "lucide-react";

export default function LandingHero() {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden pt-10 sm:pt-14 pb-12 sm:pb-16" data-testid="landing-hero">
      <div className="absolute inset-0 bg-gradient-to-br from-[#4F4CB9]/8 via-transparent to-[#E73F9A]/8 -z-10" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 bg-[#E73F9A]/10 text-[#E73F9A] border border-[#E73F9A]/30 rounded-full px-3 py-1 text-xs font-bold" data-testid="hero-eyebrow-badge">
            <Sparkles size={12} className="text-[#E73F9A]" /> AI Tutor for CBSE Class 5-9
          </span>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-4" data-testid="hero-headline">
            Your Personal <span className="text-primary">Super-Teacher.</span>
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground mt-4 max-w-lg">
            SmartGuru.io talks, listens, draws and questions like a real tutor — guiding Class 5-9 CBSE students through Math & Science with real Socratic teaching, not spoon-fed answers.
          </p>
          <div className="flex flex-wrap gap-3 mt-7">
            <button onClick={() => navigate("/onboarding")} data-testid="hero-primary-cta" className="bg-gradient-to-r from-[#4F4CB9] via-[#9A3DB2] to-[#E73F9A] text-white shadow-lg shadow-indigo-500/25 font-bold px-6 py-3.5 rounded-full flex items-center gap-2 hover:opacity-95 active:scale-95 transition-all">
              Start Learning Free <ArrowRight size={17} />
            </button>
            <a href="#voice-demo" data-testid="hero-secondary-cta" className="border-2 border-border font-bold px-6 py-3.5 rounded-full flex items-center gap-2 hover:bg-muted transition-all">
              <Mic size={17} /> Hear a Demo
            </a>
          </div>
          <div className="inline-flex items-center gap-1.5 bg-secondary/15 text-secondary-foreground border border-secondary/40 rounded-full px-3.5 py-1.5 text-xs font-bold mt-5" data-testid="hero-trial-badge">
            <Zap size={13} /> 7-Day Free Trial • No Credit Card Needed
          </div>
        </div>
        <div className="relative pb-8" data-testid="hero-visual-mockup">
          <motion.img
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
            src="https://customer-assets-jai6qajn.emergentagent.net/job_student-genius-26/artifacts/t8efct1e_Hero.png"
            alt="Indian student learning with SmartGuru on a laptop"
            className="rounded-3xl shadow-xl w-full object-cover aspect-[4/5] sm:aspect-[5/4]"
            data-testid="hero-illustration-image"
          />
          <motion.div
            initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}
            className="absolute -bottom-2 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-[280px] bg-card/95 backdrop-blur border border-border rounded-2xl p-4 shadow-xl"
            data-testid="hero-chat-demo"
          >
            <p className="text-[9px] font-bold uppercase tracking-widest text-muted-foreground mb-2">Live inside SmartGuru</p>
            <div className="bg-muted rounded-2xl rounded-tl-sm px-3.5 py-2 text-sm">
              I'm stuck on <span className="font-notebook">2x + 5 = 15</span>. What do I do?
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

